import React, { useState, useEffect } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import divisionService from '../../Devision/services';
import CSVReader from 'react-csv-reader';
import { advanceRequestFileUploadSchemaObject } from '../validations';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import Box from '@material-ui/core/Box';
import MaterialTable from "material-table";
import moment from 'moment';
import FormHelperText from "@material-ui/core/FormHelperText";
import tokenDecoder from '../../../Common/tokenDecoder';


const screenCode = 'ADVANCEREQUESTFILEUPLOAD'

export function AdvanceRequestFileUploadAdd(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Advance Request File Upload");
    const [buttonName, setButtonName] = useState("Upload")
    const [groups, setGroups] = useState([]);
    const [isChanged, setIsChanged] = useState(0);
    const [estates, setEstate] = useState();
    const [divisions, setDivision] = useState();
    const [customerData, setcustomerData] = useState([]);
    const [taskCategory, setTaskCategory] = useState();
    const [labourTask, setLabourTask] = useState();
    const [failedData, setFailedData] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState();
    const [employeeCardUpload, setEmployeeCardUpload] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        pmtNo: "0",
        dedDate: '',
        pmtDate: '',
        lineName: '',
        supNo: '0',
        supName:'',
        paidBy:'',
        amount:'0',
        sign: ''
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isFileChosen, setIsFileChosen] = useState(false);
    const [fileInfo, setFileInfo] = useState({});

    const schema = Joi.object(advanceRequestFileUploadSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [employeeCardUpload.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),

        )
    }, [employeeCardUpload.operationEntityID])


    function handleGroupChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            groupID: target.value,
            operationEntityID: "0",
            collectionPointID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            operationEntityID: target.value,
            collectionPointID: "0"

        });
    }

    function handleDivisionChange(target) {
        setEmployeeCardUpload({
            ...employeeCardUpload,
            collectionPointID: target.value

        });
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDADVANCEREQUESTFILEUPLOAD');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();

        setEmployeeCardUpload({
            ...employeeCardUpload,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(employeeCardUpload.groupID);
        setEstate(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(employeeCardUpload.operationEntityID);
        setDivision(data);
    }

    async function getTaskNames() {
        const result = await services.getAllTaskNames(employeeCardUpload.groupID, employeeCardUpload.operationEntityID);
        setTaskCategory(result);
    }

    async function handleSave() {
        let datarest = await Promise.all(customerData.map(async data => { 
           let dataobj = {
            pmtNo: parseInt(data.pmtNo),
            dedDate: moment(data.dedDate).format("YYYY-MM-DD"),
            pmtDate: moment(data.pmtDate).format("YYYY-MM-DD"),
            lineName: data.lineName,
            supNo: parseInt(data.supNo),
            supName:data.supName,
            paidBy:data.paidBy,
            amount:parseFloat(data.amount),
            sign: data.sign,
            createdDate:moment().format("YYYY-MM-DD"),
            createBy :1
           }
           return dataobj;
        }))
             
        var model = {
            collectionPointID: parseInt(employeeCardUpload.collectionPointID),
            fileUploadModel: datarest
        };

        const response = await services.AdvanceRequestFileUpload(model);
        if(response.statusCode == "Success"){

            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })

        }

        else {
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        }

        setFailedData(response.data);

        setcustomerData(response.data);        
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            collectionPointID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, advanceRequestFileUploadSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    const handleForce = (data, fileInfo) => {
        if(customerData != null){
        setIsFileChosen(true);
        setFileInfo(fileInfo);
        setEmployeeCardUpload({
            ...employeeCardUpload,
            pmtNo: data,
            dedDate: data,
            pmtDate: data,
            lineName: data,
            supNo: data,
            supName: data,
            paidBy: data,
            amount: data,
            sign: data,
        })
        confirmUpload(data,fileInfo);

    }
    }

    function confirmUpload(data, fileInfo) {
        setcustomerData(data);
    }

    function clearData() {
        setEmployeeCardUpload({
          ...employeeCardUpload,
            pmtNo: "0",
            dedDate: '',
            pmtDate: '',
            lineName: '',
            supNo: '0',
            supName:'',
            paidBy:'',
            amount:'0',
            sign: ''
        });
        setcustomerData([]);
      }
    const papaparseOptions = {
        header: true,
        dynamicTyping: false,
        quoteChar: '"',
        skipEmptyLines: true,
        parseNumbers: true,
        transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '')
    };

    return (
        <div>
            <LoadingSpinerComponent />
            <div className="card">
                <PageHeader
                    title={title}
                    isButtonEnable={false}
                />
                <div className="card-body">
                    <div className="row row-top-gap"
                         disabled={false}
                    >
                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={employeeCardUpload.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={employeeCardUpload.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={employeeCardUpload.collectionPointID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["collectionPointID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>)}
                                    </div>
                    </div>
                    <div className="col-md-4 pb-1">
                        <button className="btn" style={{ marginTop: 20, marginRight: 10, backgroundColor: '#28a761', color: '#fff !important' }}>
                            <CSVReader
                                label={isFileChosen ? 'File Chosen' : 'Choose File'}
                                onFileLoaded={handleForce}
                                parserOptions={papaparseOptions}
                                inputId="react-csv-reader-input"
                                cssClass="csv-reader-input"
                            />
                        </button>
                        {isFileChosen ? <span>{fileInfo.name}</span> : null}
                    </div>
                </div>
                
                {failedData.length > 0 ?
                    <CardHeader style={{ marginLeft: '-1rem' }} titleTypographyProps={{ variant: 'h6' }}
                            title={["Failed Records: " + failedData.length]}
                            /> : null
                 }
                                                    {customerData.length > 0 ?
                                                        <MaterialTable
                                                            
                                                            title="Employee Details"
                                                            columns={[
                                                                { title: 'Pmt No', field: 'pmtNo' },
                                                                { title: 'Ded Date', field: 'dedDate' },
                                                                { title: 'Pmt Date', field: 'pmtDate' },
                                                                { title: 'Line Name', field: 'lineName' },
                                                                { title: 'Sup No', field: 'supNo' },
                                                                { title: 'Sup Name', field: 'supName' },
                                                                { title: 'Paid By', field: 'paidBy' },
                                                                { title: 'Amount', field: 'amount' },
                                                                { title: 'Sign', field: 'sign' }
                                                            ]}
                                                            data={customerData}
                                                            options={{
                                                                exportButton: false,
                                                                showTitle: false,
                                                                headerStyle: { textAlign: "left", height: '1%' },
                                                                cellStyle: { textAlign: "left" },
                                                                columnResizable: true,
                                                                actionsColumnIndex: -1,
                                                                pageSize: 10,
                                                                padding: "dense",
                                                                tableLayout: "auto",
                                                               
                                                            }}
                                                            actions={[

                                                            ]}
                                                        /> : null}
                                                                 
                {customerData.length > 0 ?
                <Box display="flex" justifyContent="flex-end" p={2}>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                  onClick={() => (trackPromise(handleSave()))}
                    >
                        Upload
                </Button>
                </Box> : null}
                <MessageModal
                    hidden={messageModel.hidden}
                    messageType={messageModel.type}
                    messageDescription={messageModel.disciption}
                    clicked={modalDismissHandler}
                />
            </div>
        </div>
    );
}